module.exports = __webpack_public_path__ + "img/client066.106caaa7.png";